module.exports = __webpack_public_path__ + "static/media/flikidsSpanish.101514de.jpg";